//@ts-nocheck
import React, { useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls, useGLTF } from "@react-three/drei";

const DNAViewer = () => {
  const Model = () => {
    const { scene } = useGLTF("DNA.glb");
    const modelRef = useRef();

    useFrame(() => {
      if (modelRef.current) {
        modelRef.current.rotation.z += 0.01;
      }
    });

    let toggleColor = true;
    scene.traverse((child) => {
      if (child.isMesh) {
        child.material.color.set(toggleColor ? 0xffffff : 0x000000);
        toggleColor = !toggleColor;
      }
    });

    return <primitive object={scene} scale={1} ref={modelRef} />;
  };

  return (
    <div>
      <Canvas camera={{ position: [2, 2, 30], fov: 50 }}>
        <ambientLight intensity={1} />
        <directionalLight position={[2, 5, 2]} intensity={1} color={0xffffff} />
        <group rotation={[0, 0, Math.PI / 4]}>
          <Model />
        </group>
        <OrbitControls
          enablePan={false}
          enableZoom={false}
          minAzimuthAngle={Math.PI / 2}
          maxAzimuthAngle={Math.PI / 2}
        />
      </Canvas>
    </div>
  );
};

export default DNAViewer;
